import { DeviceType } from './appshellMetaTypes';

export enum ClubAdjustTrackers {
    SMARTBANNER = 'SMARTBANNER',
    DELAYSTART = 'DELAYSTART',
    FOOTER = 'FOOTER',
}

export type ClubAdjustTracker = keyof typeof ClubAdjustTrackers;

export type ClubAppLinkFunc = (
    device: DeviceType,
    fallBackFor: DeviceType,
    country: string,
    type: ClubAdjustTracker,
    appData: {
        host: string;
        loginHash?: string;
    },
    fixedDeeplink?: string
) => string;

export enum Device {
    DESKTOP = 'desktop',
    PHONE = 'mobile',
}

export type ClubHelpers = {
    getClubAppLink: ClubAppLinkFunc;
};
